<template>
  <div class="ratio-card group h-full">
    <!-- Borde lateral de color -->
    <div class="color-accent" :style="{ backgroundColor: cardColor }"></div>

    <div class="card-body">
      <!-- Gráfico circular -->
      <div class="relative flex-shrink-0 w-14 h-14">
        <svg class="w-full h-full transform -rotate-90" viewBox="0 0 36 36">
          <circle cx="18" cy="18" r="16" fill="none" stroke-width="3.5" class="circle-bg" />
          <circle
            cx="18" cy="18" r="16" fill="none"
            class="circle-progress"
            :style="{
              stroke: cardColor,
              strokeDasharray: `${percentage}, 100`
            }"
            stroke-width="3.5" stroke-linecap="round"
          />
        </svg>
        <div class="absolute inset-0 flex items-center justify-center">
          <span class="text-[10px] font-black text-slate-800">{{ percentage }}%</span>
        </div>
      </div>

      <!-- Info -->
      <div class="flex-1 min-w-0">
        <div class="mb-0.5">
          <h4 class="text-[11px] font-extrabold text-slate-900 truncate uppercase-x tracking-wider">
            {{ ratio.name }}
          </h4>
          <p class="text-[9px] text-slate-400 font-bold uppercase-x tracking-tight">
            {{ ratio.description }}
          </p>
        </div>

        <div class="flex items-baseline gap-1">
          <span class="text-2xl font-black text-slate-900 leading-none tracking-tighter">
            {{ formatNumber(ratioValue) }}
          </span>
          <span class="text-[8px] text-slate-500 font-bold uppercase-x tracking-widest">{{ $t('units') }}</span>
        </div>
      </div>

      <!-- Acciones -->
      <div v-if="showActions" class="card-actions">
        <button
          @click="$emit('epc-update-ratio', ratio)"
          class="action-btn action-btn--edit"
        >
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" /></svg>
        </button>
        <button
          @click="$emit('epc-delete-ratio', ratio)"
          class="action-btn action-btn--delete"
        >
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RatioCard',

  props: {
    ratio: {
      type: Object,
      required: true
    },
    showActions: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    cardColor() {
      return this.ratio.color || '#94a3b8';
    },

    ratioValue() {
      if (!this.ratio.formula.numerator.totalValue || !this.ratio.formula.denominator.totalValue) return 0;
      return (this.ratio.formula.numerator.totalValue / this.ratio.formula.denominator.totalValue);
    },

    percentage() {
      return Math.round(this.ratioValue * 100);
    }
  },

  methods: {
    formatNumber(num) {
      if (num == null || isNaN(num)) return '0';
      return new Intl.NumberFormat('es-BO').format(num);
    }
  }
}
</script>

<style scoped>
  .ratio-card {
    position: relative;
    border-radius: 10px;
    overflow: hidden;
    background: #fff;
    border: 1px solid #e2e8f0;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.02);
    transition: box-shadow 0.2s ease, transform 0.2s ease;
  }

  .ratio-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08), 0 2px 4px rgba(0, 0, 0, 0.04);
    transform: translateY(-1px);
  }

  .color-accent {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 4px;
    border-radius: 10px 0 0 10px;
  }

  .card-body {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 14px 16px 14px 20px;
    height: 100%;
  }

  .circle-bg {
    stroke: #f1f5f9;
  }

  .circle-progress {
    transition: stroke-dasharray 0.7s ease;
  }

  .card-actions {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-left: auto;
    opacity: 0.4;
    transition: opacity 0.15s ease;
  }

  .ratio-card:hover .card-actions {
    opacity: 1;
  }

  .action-btn {
    padding: 6px;
    border-radius: 6px;
    color: #94a3b8;
    transition: all 0.15s ease;
  }

  .action-btn--edit:hover {
    background-color: #eff6ff;
    color: #2563eb;
  }

  .action-btn--delete:hover {
    background-color: #fef2f2;
    color: #dc2626;
  }
</style>
